module.exports = __webpack_public_path__ + "static/media/def_p.705fbfcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/def_p.png
// module id = 114
// module chunks = 0